import React from 'react';
import useIsMobileView from "../../hooks/useIsMobileView";
import { Main, MainContent } from '@prosolve/common-components-ui'
import HomeEventsSection from './HomeEventsSection/HomeEventsSection';
// import HomeSessionsSection from './HomeSessionsSection/HomeSessionsSection';

// const SectionDivider = () => <div style={{ height: '10px' }}>&nbsp;</div>

export default () => {

  const isMobileView = useIsMobileView();

  return (
    <Main 
      $isMobileView={isMobileView} 
      $backgroundColor={'#f5f5f5'}
      style={{ 
        padding: '5px', 
        minHeight: 'calc(100vh - 50px)' 
      }}
    >
      <MainContent $isMobileView={isMobileView} style={{ maxWidth: '1250px' }}>
        <HomeEventsSection />
        {/* <SectionDivider />
        <HomeSessionsSection /> */}
      </MainContent>
    </Main>
  )
}
